let _registry: Record<string, () => Promise<any>> | null = null

export function setIconRegistry(registry: Record<string, () => Promise<any>>) {
  _registry = registry
}

export async function iconResolver(id: string): Promise<any> {
  if (_registry?.[id]) {
    return _registry[id]()
  }
  // Fallback: dynamic import for dev mode / when plugin is not installed
  return import(`../components/atoms/icons/${id}.js`)
}
